import React, { useState, useEffect, useMemo } from 'react';
import Listings from './components/Listings';
import MapView from './components/MapView';
import { fetchListings } from './api';
import logger from './logger';

function App() {
  logger.log('[App] Component mounting - start');
  const [listings, setListings] = useState([]);
  const [bounds, setBounds] = useState(null);
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setDebouncedQuery(query.trim().toLowerCase()), 250);
    return () => clearTimeout(t);
  }, [query]);

  const searching = debouncedQuery !== '';

  // Every field of a listing is searched; all words must match somewhere (AND)
  const visibleListings = useMemo(() => {
    if (!searching) return listings;
    const words = debouncedQuery.split(/\s+/);
    return listings.filter((l) => {
      const haystack = Object.values(l).filter((v) => v != null).join(' ').toLowerCase();
      return words.every((w) => haystack.includes(w));
    });
  }, [listings, debouncedQuery, searching]);

  const loadListings = async (currentBounds) => {
      try {
        logger.log('[App] Calling fetchListings...');
        const listings = await fetchListings(currentBounds);
        logger.log('[App] Received listings:', {
          count: listings.length,
          firstItem: listings[0] ? listings[0].id : null
        });
        setListings(listings);
      } catch (error) {
        logger.log('[App] Failed to load listings:', {
          error: error.message,
          stack: error.stack
        });
      }
    };
  

  // Runs on mount (bounds is null -> all listings) and whenever the map bounds change.
  // While searching, load everything so matches outside the current view are found too.
  useEffect(() => {
    loadListings(searching ? null : bounds);
  }, [bounds, searching]);

  return (
    <div className="app-container">
      <button
        onClick={() => logger.download()}
        style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          zIndex: 1000,
          padding: '5px 10px',
          background: '#333',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Download Logs
      </button>
      <Listings
        listings={visibleListings}
        count={visibleListings.length}
        query={query}
        onQueryChange={setQuery}
      />
      <MapView
        listings={visibleListings}
        fitToListings={searching}
        onBoundsChange={setBounds}
      />
    </div>
  );
}

export default App;